import i18n from 'i18next';

import { ProjectBillingModel } from '../types/project';

/**
 * Gets localized label for billing model
 */
export const getBillingModelLabel = (value: ProjectBillingModel | null): string => {
  switch (value) {
    case ProjectBillingModel.TM:
      return i18n.t('authenticated.projects:filters.timeMaterial');
    case ProjectBillingModel.FixedPrice:
      return i18n.t('authenticated.projects:filters.fixedPrice');
    case ProjectBillingModel.NonBillable:
      return i18n.t('authenticated.projects:filters.nonBillable');
    default:
      return i18n.t('common:table.noValue');
  }
};
